import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { featureFlags as buildTimeFlags } from '../config/featureFlags';
import { getMeidaisaiFeatureFlags, isMeidaisaiRoute } from '../config/meidaisaiDemo';

const FeatureFlagsContext = createContext(buildTimeFlags);

export function FeatureFlagsProvider({ children }) {
  const { pathname } = useLocation();
  const flags = useMemo(
    () => (isMeidaisaiRoute(pathname) ? getMeidaisaiFeatureFlags() : buildTimeFlags),
    [pathname],
  );

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}
